import React, { ChangeEventHandler } from 'react';

import { ISlider } from '@/components/global/SmSlider/types';
import { SmSlider } from '@/components/global/SmSlider';

import { TTagList } from '@/services/requests/Recommendation/types/template6';

export const Calculator = ({
  inputValue,
  handleSliderChange,
  tags,
}: {
  inputValue: number;
  handleSliderChange: ISlider['onChange'];
  tags: TTagList;
}) => {
  const handleRadioChange: ChangeEventHandler<HTMLInputElement> = e => {
    handleSliderChange?.({
      curMin: 6000,
      curMax: parseInt(e.target.value, 10),
    });
  };

  if (!tags.length) return null;

  return (
    <div className="vitrine-template6__calculator">
      <div className="vitrine-template6__calculator__top">
        <SmSlider
          variant="single"
          min={1}
          max={tags.length}
          step={1}
          defaultValue={inputValue}
          onChange={handleSliderChange}
        />
      </div>
      <div className="vitrine-template6__calculator__bottom">
        {tags.map(({ id, miles, description }, index) => {
          return (
            <label
              className="vitrine-template6__calculator__item"
              htmlFor={miles}
              key={id}
            >
              <input
                type="radio"
                name="calculator"
                id={miles}
                value={index + 1}
                checked={inputValue === index + 1}
                onChange={handleRadioChange}
                data-testid="input-slider"
              />
              <div className="text">{description}</div>
            </label>
          );
        })}
      </div>
    </div>
  );
};
